import * as React from 'react';

// CSSを書くのが面倒だからhover stateを持たせただけのCloseButton, たぶんデザイン適用時に消す

export interface CloseButtonProps {
  onClick: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
}

interface CloseButtonState {
  hovered: boolean;
}

class CloseButton extends React.Component<CloseButtonProps, CloseButtonState> {
  public constructor(props: CloseButtonProps) {
    super(props);
    this.state = {
      hovered: false,
    };
  }

  public render() {
    const style: React.CSSProperties = {
      float: 'right',
      color: this.state.hovered ? 'red' : 'white',
    };

    return (
      <a
        className="material-icons"
        onClick={this.props.onClick}
        onMouseEnter={() => this.setState({ hovered: true })}
        onMouseLeave={() => this.setState({ hovered: false })}
        style={style}>
        close
      </a>
    );
  }
}

export default CloseButton;
